import axios from "axios"
import { getEnvKey } from "../environment"
import { buildNCDHeaders, ENV } from "../utils"

export const getSession = (agentId: string | undefined, appId: string) => {
  return axios
    .get(getEnvKey(ENV.REACT_APP_SESSIONIDLAMBDAURL) as string, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        ...buildNCDHeaders(agentId, appId),
      },
      params: {
        TableName: "metlife-applications",
        Key: appId,
      },
    })
}